<template>
  <div>

    <!-- Request Privacy Consent Modal -->
    <x-modal
      width="650"
      v-if="submitModal.visible == true"
      @cancel="submitModal.visible = false"
      @close="submitModal.visible = false"
      @ok="completeStepButton"
      :draggable="true"
      :resizable="true"
      :loading="loading"
      okText="Request Privacy Consent">

      <div slot="title" :class="`d-flex justify-content-between align-items-center`">
        Request Privacy Consent
      </div>

      <div class="container">
        <div class="row pt-0 amb-modal-body">
          <div class="col-12 my-3">

            <div v-if="submitModal.formData.sendEmail">
              <p class="mb-1">
                <strong>To</strong>
              </p>
              <div v-for="(applicant, index) in applicants" :key="applicant.applicantId">
                <div class="d-flex align-items-center amb-toggle-row-modal mb-1">
                  <div class="amb-table-check-container mr-2">
                    <input
                      class="table-checkbox"
                      type="checkbox"
                      :value="{id: applicant.applicantId, email: applicant.email}"
                      v-model="submitModal.formData.to"
                      :checked="submitModal.formData.to.some(to => to.email == applicant.email && to.id == applicant.id)"
                      :disabled="!submitModal.formData.sendEmail"
                    />
                    <span class="amb-table-checkmark"></span>
                  </div>
                  <p>{{ applicant.firstName}} {{ applicant.lastName }} ({{ applicant.email }})</p>
                  <b-badge variant="primary" v-if="applicant.use_alias">Primary Applicant Email</b-badge>
                </div>
                <div
                  class="d-flex align-items-center amb-toggle-row-modal mb-1"
                  v-if="applicant.email2"
                >
                  <div class="amb-table-check-container mr-2">
                    <input
                      class="table-checkbox"
                      type="checkbox"
                      :value="{id: applicant.applicantId, email: applicant.email2}"
                      v-model="submitModal.formData.to"
                      :checked="submitModal.formData.to.some(to => to.email == applicant.email2 && to.id == applicant.id)"
                      :disabled="!submitModal.formData.sendEmail"
                    />
                    <span class="amb-table-checkmark"></span>
                  </div>
                  <p>
                    {{ applicant.firstName}} {{ applicant.lastName }} ({{ applicant.email2 }})
                    <span
                      class="ml-2 badge badge-secondary btn-light-blue"
                    >Secondary</span>
                  </p>
                </div>
              </div>

              <application-input
                class="input-belt my-3"
                v-model="submitModal.formData.subject"
                :disabled="!submitModal.formData.sendEmail"
              >Subject</application-input>

              <div class="input-belt mb-4">
                <h3 for="email-comments">Email Comments</h3>
                <small>
                  Enter any notes or comments to be included as 'broker notes' in email to the
                  customer
                </small>

                <summernote
                  :model.sync="submitModal.formData.emailComments"
                  :disabled="!submitModal.formData.sendEmail"
                ></summernote>

                <a
                  href="#"
                  class="text-btn-l-blue-bold mt-2 text-right"
                  @click.prevent="previewEmail"
                >
                  <i class="fas fa-eye ml-1"></i> Preview Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </x-modal>
    <!-- End modal -->
  </div>
</template>


<script>
import { Message } from "element-ui";
import DefaultTemplate from "@ambition/components/application-steps/scripts/DefaultTemplate";
export default {
  props: {
    open: Boolean,
    applicants: Array
  },
  data() {
    return {
      loading: false,
      emailTemplate: null,
      submitModal: {
        formData: {
          emailComments: "",
          subject: null,
          to: [],
          cc: "",
          sendEmail: true,
          remindMe: new Date(),
          taskName: "",
          time: "17:00"
        },
        visible: false,
        submitting: false
      }
    };
  },
  methods: {
    async getDefaultTemplate() {
      try {

        let request = new DefaultTemplate(
          null,
          this.$store.getters.token,
          "Conditioning - Manual Privacy Consent Request"
        );
        const res = await request.getTemplateByName();
        this.emailTemplate = res;

        if (this.emailTemplate) {
          this.submitModal.formData.subject = this.emailTemplate.subject;
        }
      } catch (err) {
        console.error(err);
      }
    },
    previewEmail() {
      axios
        .post("/admin/preview/mail/" + this.$store.getters.initAppData.id, {
          notes: this.submitModal.formData.emailComments,
          status_id: "privacy-consent-request"
        })
        .then(res => {
          window.open(
            "/admin/preview/mail/" +
              this.$store.getters.initAppData.id +
              "?status_id=privacy-consent-request"
          );
        })
        .catch(err => {
          console.error(err.response.data);
        });
    },

    completeStepButton() {
      this.loading = true;
      const header = {
        headers: { Authorization: "Bearer " + this.$store.getters.token }
      };
      this.submitModal.submitting = true;
      axios
        .patch(
          `/api/v3/privacy-consent/${this.$store.getters.initAppData.id}`,
          {
            to: this.submitModal.formData.to,
            cc: this.submitModal.formData.cc,
            comment: this.submitModal.formData.emailComments,
            subject: this.submitModal.formData.subject
          },
          header
        )
        .then(res => {
          this.loading = false;
          this.$bus.$emit("privacy-consent-requested", res.data.to);
          this.submitModal.visible = false;
          Message({
            message: "Privacy Consent Requested",
            type: "success"
          });
        })
        .catch(err => {
          console.error(err);
          this.loading = false;
          Message({
            message: "Request Failed",
            type: "error"
          });
        })
        .finally(() => {
          this.loading = false;
          this.submitModal.submitting = false;
        });
    }
  },
  watch: {
    "submitModal.visible"(newVal, oldVal) {
      this.$emit("update:open", newVal);
    },
    open(newVal, oldVal) {
      this.submitModal.visible = newVal;

      if (newVal) {
        this.getDefaultTemplate();
      }
    }
  }
};
</script>
